var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"battle-org-info"},[_c('v-avatar',{attrs:{"size":"40"}},[_c('img',{attrs:{"src":_setup.getImageById(_vm.chip.image, 80, 80, 'org'),"alt":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }